import API from "@app/services/api";

/** The `folder` filter of `GET /dataset/` for « Sans classeur ». */
export const UNFILED = "none";

/** A classeur the team files laboratory datasets in (PT-112). */
export interface DatasetFolder {
  id: string;
  name: string;
  specialite: string | null;
  /** The datasets of this classeur the session may open. */
  dataset_count: number;
  can_write: boolean;
}

export interface DatasetShelf {
  folders: DatasetFolder[];
  unfiled_count: number;
}

export async function fetchShelf(): Promise<DatasetShelf> {
  const res = await API.get({ path: "/dataset-folder/" });
  if (!res.ok || !res.data) throw new Error(res.error);
  return res.data as DatasetShelf;
}

export async function createFolder(name: string): Promise<DatasetFolder> {
  const res = await API.post({ path: "/dataset-folder/", body: { name } });
  if (!res.ok || !res.data) throw new Error(res.error);
  return res.data as DatasetFolder;
}

export async function renameFolder(id: string, name: string): Promise<void> {
  const res = await API.put({ path: `/dataset-folder/${id}`, body: { name } });
  if (!res.ok) throw new Error(res.error);
}

export async function deleteFolder(id: string): Promise<void> {
  const res = await API.delete({ path: `/dataset-folder/${id}` });
  if (!res.ok) throw new Error(res.error);
}

/** Files a dataset in a classeur, or takes it out with `null`. */
export async function fileDataset(
  datasetId: string,
  folderId: string | null,
): Promise<void> {
  const res = await API.put({
    path: `/dataset/${datasetId}/folder`,
    body: { folder_id: folderId },
  });
  if (!res.ok) throw new Error(res.error);
}
